export default function Alert({ error }) {
  return (
    <div className="rounded-md bg-red-50 p-4 z-10">
      <div className="flex">
        <div className="flex-shrink-0"></div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            There were errors with your submission
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <ul className="list-disc pl-5 space-y-1">
              <li>{error}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
